import React from 'react';
import './carouselLogo.css'

const Logo = (props) => {
    return ( 
        <img className='carouselLogo' src={props.logo} alt="" />
     );
}
 
export default Logo;